export interface CatalogMaterial {
  id: number | string
  name: string
  unit?: string
  price?: number
}

export interface MaterialDetailCategory {
  id: number | string
  name: string
  description?: string | null
}

export interface MaterialDetailCommerceInfo {
  id: number | string
  name: string
  zone?: string | null
  latitude?: string | null
  longitude?: string | null
  ownerUserId?: number | string | null
  user_id?: number | string | null
  userId?: number | string | null
}

export interface MaterialDetailCommerceRow {
  id: number | string
  description?: string | null
  price?: number | null
  promotion?: string | null
  promotion_discount?: number | null
  unquoted?: boolean
  value_added_tax?: boolean
  ownerUserId?: number | string | null
  commerce?: MaterialDetailCommerceInfo | null
}

export interface MaterialDetail {
  id: number | string
  name: string
  description?: string | null
  price?: number | null
  unquoted?: boolean
  temporary?: boolean
  unit?: string | null
  brand?: string | null
  category?: MaterialDetailCategory | null
  materials_commerce?: MaterialDetailCommerceRow[]
}

export interface CategoryFromApi {
  id: number | string
  name: string
  materials?: CatalogMaterial[]
  jurisdiction?: unknown
  currency?: string
}

export interface CategoriesResponse {
  data?: CategoryFromApi[]
}

export interface SelectedMaterial {
  id: number | string
  name: string
  unit: string
  quantity: number
  category: string
  price?: number
  temporary?: boolean
  currency?: string
  categoryId?: number | string
  rawName?: string
  inCatalog?: boolean
  catalogMaterialUnquoted?: boolean
}

export const MATERIALS_FOR_ESTIMATION_STATE_KEY = "materialsForEstimation" as const

export const MATERIALS_FOR_QUOTATION_STATE_KEY = "materialsForQuotation" as const

export type CalculadoraEstimationTransferLocationState = {
  [MATERIALS_FOR_ESTIMATION_STATE_KEY]?: SelectedMaterial[]
}

export type CalculadoraQuotationTransferLocationState = {
  [MATERIALS_FOR_QUOTATION_STATE_KEY]?: SelectedMaterial[]
}

export function isMaterialOutOfCatalog(m: SelectedMaterial): boolean {
  if (typeof m.inCatalog === "boolean") return !m.inCatalog
  return Boolean(m.temporary)
}

export interface SubquotationCategory {
  name: string
  materials: Array<{ id: number | string; name: string; unit?: string; amount?: number }>
}

export interface QuotationData {
  quotation?: { name?: string; user?: { id: number | string } }
  subquotation?: Array<{ id: number | string }>
}

export interface UserData {
  id: number | string
}

export interface CalculadoraReduxState {
  category: { categories: CategoriesResponse }
  profile: {
    quotation: QuotationData | null
    materialsBySubquotation: Record<string, SubquotationCategory[]> | null
  }
  general: { userData: UserData | null }
}

export interface MainModalConfig {
  title: string
  body: string
  iconType: string
  noLabel?: string
  yesLabel?: string
  confirmHandler: (() => void) | null
  customCloseMainModal?: () => void
  isSuccess?: boolean
}

export interface CalculadoraDispatchProps {
  getCategoriesWithMaterials: () => Promise<void>
  getMaterialsBySubquotationId: (subquotationId: number | string) => Promise<void>
  editSubquotationMaterials: (
    subquotationId: number | string,
    materials: Array<{
      category_id: number
      material_id: number | string
      temporary: boolean
      amount: number
      name: string
      unit: string
    }>,
    navigate: (path: string) => void
  ) => Promise<void>
  openMainModal: (config: MainModalConfig) => void
  closeMainModal: () => void
}

export type CalculadoraProps = CalculadoraDispatchProps & {
  categoriesWithMaterials: CategoriesResponse
  quotationData: QuotationData | null
  materialsBySubquotation: Record<string, SubquotationCategory[]> | null
  userData: UserData | null
}
